// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__25ADi","left":"styles_left__LQd8z"};